import { Flex, Tooltip, Typography } from 'antd';
import PropTypes from 'prop-types';
import Icon from '@ant-design/icons';
import { TRIP_VIDEO_STATUS } from '../../../utilities/constants';
import '../TripSurveillanceAndAnalysis.css';

const { Text } = Typography;

const TimelineCard = ({
  key,
  IconComponent,
  thumbnailImage,
  timestamp,
  onClick,
  isSOS = false,
  isSelected = false,
  vodStatus = TRIP_VIDEO_STATUS.UNAVAILABLE,
}) => {
  const getTooltipTitle = () => {
    if (vodStatus === TRIP_VIDEO_STATUS.ERROR) {
      return 'Video is not available for this segment';
    } else if (vodStatus === TRIP_VIDEO_STATUS.INPROGRESS) {
      return 'Video request is under process';
    } else if (vodStatus === TRIP_VIDEO_STATUS.UNAVAILABLE) {
      return 'Request video for this segment';
    }
    return '';
  };
  return (
    <Flex
      key={key}
      vertical
      className={`timeline-card-flex ${onClick && 'cursor-pointer'}`}
      onClick={onClick}
    >
      {/* thumbnail */}
      {vodStatus !== TRIP_VIDEO_STATUS.ERROR && (
        <div
          className={`timeline-card-thumbnail-wrapper ${
            vodStatus === TRIP_VIDEO_STATUS.AVAILABLE && isSelected
              ? 'timeline-card-thumbnail-selected'
              : ''
          }`}
        >
          <img
            src={`data:${thumbnailImage?.mimeType};base64,${thumbnailImage?.data}`}
            alt="trip video thumbnail"
            className={`timeline-card-thumbnail-img${
              vodStatus !== TRIP_VIDEO_STATUS.AVAILABLE
                ? ' timeline-card-thumbnail-blur'
                : ''
            }`}
            width={thumbnailImage?.width || 160}
            height={thumbnailImage?.height || 90}
          />
        </div>
      )}
      {/* SOS Badge */}
      {isSOS && <Text className="timeline-card-sos-badge">SOS</Text>}
      {/* Overlay icon */}
      {IconComponent ? (
        vodStatus === TRIP_VIDEO_STATUS.ERROR ||
        vodStatus === TRIP_VIDEO_STATUS.INPROGRESS ||
        vodStatus === TRIP_VIDEO_STATUS.UNAVAILABLE ? (
          <Tooltip title={getTooltipTitle}>
            <div
              style={{
                fontSize: 45,
                flexGrow: 1,
                alignContent: 'center',
                textAlign: 'center',
                zIndex: 1,
              }}
            >
              <Icon
                component={IconComponent}
                style={{ color: 'transparent' }}
              />
            </div>
          </Tooltip>
        ) : (
          <div
            style={{
              fontSize: 45,
              flexGrow: 1,
              alignContent: 'center',
              textAlign: 'center',
              zIndex: 1,
            }}
          >
            <Icon component={IconComponent} style={{ color: 'transparent' }} />
          </div>
        )
      ) : (
        <div style={{ flexGrow: 1 }}></div>
      )}
      {/* Time label */}
      <div
        className={`timeline-card-time-label${
          vodStatus !== TRIP_VIDEO_STATUS.AVAILABLE
            ? ' timeline-card-time-label-bg'
            : ''
        }`}
      >
        {timestamp}
      </div>
    </Flex>
  );
};

TimelineCard.propTypes = {
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  IconComponent: PropTypes.elementType,
  thumbnailImage: PropTypes.shape({
    mimeType: PropTypes.string,
    data: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  timestamp: PropTypes.string,
  onClick: PropTypes.func,
  isSOS: PropTypes.bool,
  isSelected: PropTypes.bool,
  vodStatus: PropTypes.string,
};

export default TimelineCard;
